import React from "react";
import DateTimeInput from "../fields/DateTimeInput";

const EmergencyRoomCPRSection = ({ formData, setFormData }) => {
  return (
    <section className="form-section">
      <h3>3-3. 응급실 심폐소생</h3>

      {/* 응급실 소생술 시도 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">응급실 소생술 시도</label>
          <div className="input_1col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="ED_CPR"
                  value={value}
                  checked={formData.ED_CPR === value}
                  onChange={(e) =>
                    setFormData({ ...formData, ED_CPR: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 소생술 미시행 이유 */}
      {formData.ED_CPR === "아니오" && (
        <div className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">소생술 미시행 이유</label>
            <div className="input_1col">
              {["도착 시 ROSC", "소생가능성희박", "DNR"].map((value) => (
                <label key={value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="ED_CPR_cause"
                    value={value}
                    checked={formData.ED_CPR_cause === value}
                    onChange={(e) =>
                      setFormData({ ...formData, ED_CPR_cause: e.target.value })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{value}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      )}

      {formData.ED_CPR === "예" && (
        <>
          {/* 응급실 흉부압박 시작 시각 */}
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                응급실 흉부압박 시작 시각
              </label>
              <div className="input_2col">
                <DateTimeInput
                  id="ED_CPR_datetime"
                  value={formData.ED_CPR_datetime || ""}
                  onChange={(datetime) =>
                    setFormData({ ...formData, ED_CPR_datetime: datetime })
                  }
                />
              </div>
            </div>
          </div>

          {/* 응급실에서 첫 리듬 */}
          <div className="input-wrapper-1column">
            <div className="block-1column">
              <label className="item_title_1col">응급실에서 첫 리듬</label>
              <div className="input_1col">
                {[
                  "ROSC상태",
                  "VF",
                  "pVT",
                  "PEA",
                  "asystole",
                  "shockable",
                  "non-shockable",
                ].map((value) => (
                  <label key={value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ED_rhythm"
                      value={value}
                      checked={formData.ED_rhythm === value}
                      onChange={(e) =>
                        setFormData({ ...formData, ED_rhythm: e.target.value })
                      }
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{value}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* 응급실 제세동시도 */}
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">응급실 제세동시도</label>
              <div className="input_2col">
                {["예", "아니오"].map((value) => (
                  <label key={value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ED_defib"
                      value={value}
                      checked={formData.ED_defib === value}
                      onChange={(e) =>
                        setFormData({ ...formData, ED_defib: e.target.value })
                      }
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{value}</div>
                  </label>
                ))}
              </div>
            </div>
            {formData.ED_defib === "예" && (
              <div className="block-2column">
                <label className="item_title_2col">응급실 첫 제세동 시각</label>
                <div className="input_2col">
                  <DateTimeInput
                    id="ED_defib_datetime"
                    value={formData.ED_defib_datetime || ""}
                    onChange={(datetime) =>
                      setFormData({ ...formData, ED_defib_datetime: datetime })
                    }
                  />
                </div>
              </div>
            )}
          </div>

          {/* 기타 처치 항목들 */}
          {[
            {
              label: "응급실 기관내 삽관",
              name: "ED_intubation",
              timeName: "ED_intubation_datetime",
            },
            {
              label: "응급실 에피네프린 투여",
              name: "ED_epi",
              timeName: "ED_epi_datetime",
            },
            {
              label: "응급실 아미오다론 투여",
              name: "ED_amio",
              timeName: "ED_amio_datetime",
            },
            {
              label: "CPR 중 C-line 삽입",
              name: "ED_central",
              timeName: "ED_CVC_insert_datetime",
            },
            {
              label: "CPR 중 A-line 삽입",
              name: "ED_Aline",
              timeName: "ED_Aline_insert_datetime",
            },
          ].map(({ label, name, timeName }) => (
            <div key={name} className="input-wrapper-2column">
              <div className="block-2column">
                <label className="item_title_2col">{label}</label>
                <div className="input_2col">
                  {["예", "아니오"].map((value) => (
                    <label key={value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name={name}
                        value={value}
                        checked={formData[name] === value}
                        onChange={(e) =>
                          setFormData({ ...formData, [name]: e.target.value })
                        }
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{value}</div>
                    </label>
                  ))}
                </div>
              </div>
              {formData[name] === "예" && (
                <div className="block-2column">
                  <label className="item_title_2col">{`${label} 시각`}</label>
                  <div className="input_2col">
                    <DateTimeInput
                      id={timeName}
                      value={formData[timeName] || ""}
                      onChange={(datetime) =>
                        setFormData({ ...formData, [timeName]: datetime })
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          ))}

          {/* NIRS, REBOA, ECPR */}
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">NIRS</label>
              <div className="input_2col">
                {["예", "아니오"].map((value) => (
                  <label key={value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="NIRS"
                      value={value}
                      checked={formData.NIRS === value}
                      onChange={(e) =>
                        setFormData({ ...formData, NIRS: e.target.value })
                      }
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{value}</div>
                  </label>
                ))}
              </div>
            </div>
            <div className="block-2column">
              <label className="item_title_2col">REBOA</label>
              <div className="input_2col">
                {["예", "아니오"].map((value) => (
                  <label key={value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="REBOA"
                      value={value}
                      checked={formData.REBOA === value}
                      onChange={(e) =>
                        setFormData({ ...formData, REBOA: e.target.value })
                      }
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{value}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* ECPR */}
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">ECPR</label>
              <div className="input_2col">
                {["예", "아니오"].map((value) => (
                  <label key={value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ECPR"
                      value={value}
                      checked={formData.ECPR === value}
                      onChange={(e) =>
                        setFormData({ ...formData, ECPR: e.target.value })
                      }
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{value}</div>
                  </label>
                ))}
              </div>
            </div>
            {formData.ECPR === "예" && (
              <div className="block-2column">
                <label className="item_title_2col">Pump on time</label>
                <div className="input_2col">
                  <DateTimeInput
                    id="pump_on_time"
                    value={formData.pump_on_time || ""}
                    onChange={(datetime) =>
                      setFormData({ ...formData, pump_on_time: datetime })
                    }
                  />
                </div>
              </div>
            )}
          </div>

          {/* ROSB 관련 필드 추가 */}
          {formData.ECPR === "예" && (
            <div className="input-wrapper-2column">
              <div className="block-2column">
                <label className="item_title_2col">ROSB</label>
                <div className="input_2col">
                  {["예", "아니오"].map((value) => (
                    <label key={value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ROSB"
                        value={value}
                        checked={formData.ROSB === value}
                        onChange={(e) =>
                          setFormData({ ...formData, ROSB: e.target.value })
                        }
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{value}</div>
                    </label>
                  ))}
                </div>
              </div>
              {formData.ROSB === "예" && (
                <div className="block-2column">
                  <label className="item_title_2col">ROSB time</label>
                  <div className="input_2col">
                    <DateTimeInput
                      id="ROSB_time"
                      value={formData.ROSB_time || ""}
                      onChange={(datetime) =>
                        setFormData({ ...formData, ROSB_time: datetime })
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </section>
  );
};

export default EmergencyRoomCPRSection;
